
<div class="flex p-2">
    <div class="flex-1 flex align-items-center justify-content-center">
        <h4>We're sorry the page you were looking for could not be found.</h4>
    </div>
</div>